import * as React from 'react'

const ExclamationCircle2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Exclamation Circle logo'
    fill='none'
    height='18'
    role='img'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Exclamation Circle logo</title>
    <circle cx='12' cy='12' r='10' />
    <line x1='12' x2='12' y1='8' y2='12' />
    <line x1='12' x2='12.01' y1='16' y2='16' />
  </svg>
)

export default ExclamationCircle2



// WEBPACK FOOTER //
// ./src/components/icons/ui/ExclamationCircle2.tsx